import React from 'react';
import { useParams } from 'react-router-dom';
import DownloadRedirect from './DownloadRedirect';

const LocalizedDownloadRedirect: React.FC = () => {
  const { locale } = useParams<{ locale?: string }>();
  return <DownloadRedirect forceLanguage={locale} />;
};

export default LocalizedDownloadRedirect;
